<template>
  <v-card class="pa-4">
    <div class="d-flex align-center justify-space-between">
      <h2>{{ $t('Dados do contrato') }}</h2>
      <div class="d-flex">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="userType != 3"
              class="ma-1"
              color="#f5f5f5"
              dark
              @click="uploadDocument(currentContract)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon small color="#0F3565">
                mdi-file-document-multiple-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Documentos anexados') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="userType != 3"
              class="ma-1"
              color="#f5f5f5"
              dark
              @click="editContract(currentContract)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon dark color="#0F3565"> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>
      </div>
    </div>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0">
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Instituição') }}:</strong>
          {{
            currentContract.institution
              ? currentContract.institution.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Unidades') }}:</strong>
          {{
            currentContract.unidades
              ? currentContract.unidades.map((x) => x.unidade.name).join(', ')
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Nº contrato') }}:</strong>
          {{ currentContract.number }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Contrato (apelido)') }}:</strong>
          {{
            currentContract.name != null
              ? currentContract.name
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Cobertura') }}:</strong>
          {{ $t(coverages[currentContract.eContractCoverage]) }}
        </p>
      </v-col>
      <v-col cols="8" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Valor contrato') }}:</strong>
          {{
            contractValue != 0
              ? `${contractValue.toInstLocale()}`
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col cols="4" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Quantidade') }}:</strong>
          {{ currentContract.quantity }}
        </p>
      </v-col>

      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Índice reajuste') }}:</strong>
          {{
            currentContract.indexReadjustment != null
              ? currentContract.indexReadjustment
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Horário cobertura') }}:</strong>
          {{
            currentContract.coverageTime != null
              ? currentContract.coverageTime
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Tempo atendimento') }}:</strong>
          {{
            currentContract.serviceTime != null
              ? `${currentContract.serviceTime} hrs`
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Cláusula uptime') }}:</strong>
          {{
            currentContract.uptimeClause != null
              ? `${new Intl.NumberFormat('pt-bt').format(
                  currentContract.uptimeClause
                )} %`
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Início vigência') }}:</strong>
          {{ formatDate(currentContract.startDate) }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Fim vigência') }}:</strong>
          {{ formatDate(currentContract.endDate) }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p>
          <strong class="field">{{ $t('Data reajuste') }}:</strong>
          {{ formatDate(currentContract.readjustmentDate) }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <p>
          <strong class="field">{{ $t('Fornecedor') }}:</strong>
          {{
            currentContract.supplier
              ? currentContract.supplier.name
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Observações') }}:</strong>
          {{
            currentContract.observation != null
              ? currentContract.observation
              : $t('Sem registro')
          }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0">
      <v-col class="py-0" cols="12">
        <h3>{{ $t('Equipamentos cobertos') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-data-table
          :headers="headersMobile"
          :items="currentContract.equipment"
          class="hidden-md-and-up"
          hide-default-footer
          :mobile-breakpoint="330"
          :single-expand="false"
          :items-per-page="
            currentContract.equipment ? currentContract.equipment.length : 10
          "
          :expanded.sync="expanded"
          @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
        >
          <template v-slot:item.identification="{ item }">
            {{
              item.identification != null
                ? item.identification
                : $t('Sem registro')
            }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-col class="ma-0 pa-0" cols="12">
                <p>
                  <strong> Eq.padrão: </strong>
                  {{
                    item.standardEquipmentId != 0
                      ? standardEquipmentName
                      : $t('Sem registro')
                  }}
                </p>
              </v-col>
              <v-col class="ma-0 pa-0" cols="12">
                <p>
                  <strong> Modelo: </strong>
                  {{ item.model }}
                </p>
              </v-col>
              <v-col class="ma-0 pa-0" cols="12">
                <p>
                  <strong>Valor: </strong>
                  {{ ` ${item.contractValue.toInstLocale()}` }}
                </p>
              </v-col>
              <v-col v-show="userType != 3" class="ma-0 pa-0" cols="12">
                <v-btn
                  x-small
                  color="#A42A2AD9"
                  dark
                  depressed
                  @click.stop="openRemoveDialog(item)"
                >
                  <v-icon x-small>mdi-link-variant-off</v-icon>
                  {{ $t('Remover do contrato') }}
                </v-btn>
              </v-col>
            </td>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <p class="label">
          {{
            $t(
              '*Equipamentos alienados são marcados com a identificação em vermelho'
            )
          }}
        </p>
        <v-data-table
          :headers="headers"
          :items="currentContract.equipment"
          :items-per-page="
            currentContract.equipment ? currentContract.equipment.length : 10
          "
          class="main-table hidden-sm-and-down"
          hide-default-footer
          hide-default-header
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template v-slot:item.identification="{ item }">
            <span :style="item.alienated ? 'color: red' : ''">
              {{
                item.identification != null
                  ? item.identification
                  : $t('Sem registro')
              }}
            </span>
          </template>
          <template v-slot:item.standardEquipment="{ item }">
            {{
              item.institutionStandardEquipmentId
                ? item.standardEquipment.name
                : $t('Sem registro')
            }}
          </template>
          <template v-slot:item.model="{ item }">
            {{ item.model != null ? item.model : $t('Sem registro') }}
          </template>
          <template v-slot:item.contractValue="{ item }">
            {{ ` ${item.contractValue.toInstLocale()}` }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-show="userType != 3"
              x-small
              color="#A42A2AD9"
              dark
              depressed
              @click.stop="openRemoveDialog(item)"
            >
              <v-icon x-small>mdi-link-variant-off</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="removeDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja remover este equipamento do contrato?') }}
          </div>
          <v-btn
            :disabled="removeLoading"
            class="ma-1"
            color="grey"
            text
            @click="removeDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-btn
            :loading="removeLoading"
            class="ma-1"
            color="error"
            text
            @click="confirmRemove"
          >
            {{ $t('Remover') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
  </v-card>
</template>

<style scoped>
#header {
  display: flex;
  justify-content: space-between;
}
.field {
  display: block;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import Utils from '../../../../Utils/FormatDate'

export default {
  props: {
    receivedContract: {
      type: Object,
      required: true,
    },
  },

  async created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (this.receivedContract) {
      await this.getContract()
    }
    this.contractValue = new Intl.NumberFormat('pt-br').format(
      this.receivedContract.value
    )
  },

  data: () => ({
    expanded: [],
    currentContract: {},
    dialogKey: false,
    editDialog: false,
    institutionName: '',
    unidadeName: '',
    supplierName: '',
    standardEquipmentName: '',
    contractValue: '',
    userType: null,
    coverages: [
      'Calibração',
      'Corretiva e Preventiva',
      'Locação / Comodato',
      'Manutenção preventiva',
      'Manutenção corretiva',
      'Outros',
      'Validação de equipamentos',
    ],
    removeDialog: false,
    equipmentToRemove: null,
    removeLoading: false,
    apiService: new ApiService(),
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Nº identificação',
        align: 'center',
        value: 'identification',
        sortable: false,
      },
      {
        text: 'Equipamento padrão',
        align: 'center',
        value: 'standardEquipment',
        sortable: false,
      },
      {
        text: 'Modelo',
        align: 'center',

        value: 'model',
        sortable: false,
      },
      {
        text: 'Valor',

        align: 'center',
        value: 'contractValue',
        sortable: false,
      },
      {
        text: '',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 60,
      },
    ],
    headersMobile: [
      {
        text: 'Nº identificação',
        align: 'center',

        value: 'identification',
        sortable: false,
      },
    ],
  }),

  methods: {
    async getContract() {
      this.apiService
        .get(`contract/${this.institutionId}/${this.receivedContract.id}`)
        .then((response) => {
          this.currentContract = response.content
        })
    },

    close() {
      this.$emit('close')
    },

    closeDialog() {
      this.editDialog = false
      this.dialogKey = !this.dialogKey
    },

    uploadDocument(contract) {
      sessionStorage.clear()
      this.currentContract = contract
      sessionStorage.setItem('contract', JSON.stringify(this.currentContract))
      this.$router.push({ path: '/uploadDocument' })
    },

    editContract(contract) {
      this.currentContract = contract
      sessionStorage.setItem('contract', JSON.stringify(this.currentContract))
      this.$router.push({ name: 'editContract' })
    },

    openRemoveDialog(equipment) {
      this.equipmentToRemove = equipment
      this.removeDialog = true
    },

    async confirmRemove() {
      this.removeLoading = true
      await this.apiService
        .delete(`equipment/removeFromContract/${this.equipmentToRemove.id}/${this.receivedContract.id}`)
        .then(() => {
          this.getContract()
        })
      this.removeLoading = false
      this.removeDialog = false
    },

    formatDate(date) {
      return Utils.moment(date)
    },
  },
}
</script>

<style></style>
